export enum StatConsentEnvironment {
    WEB = "web",
    AMP = "amp",
}
